import { AiFillCheckCircle, AiFillFlag } from "react-icons/ai";
import { type SxProps, type Theme } from "@mui/material/styles";

import { Box } from "ui/box";

import { classMerge } from "utilities/css";

import { colors, themeColors } from "design-tokens";

export interface CommentIconsProps {
  canFlag?: boolean;
  canOpen?: boolean;
  isChecked?: boolean;
  isFlagged?: boolean;
  toggleFlag: () => void;
  toggleCheck: () => void;
  sx?: SxProps<Theme>;
}

export const CommentIcons = ({
  canFlag,
  canOpen,
  isChecked,
  isFlagged,
  toggleCheck,
  toggleFlag,
  sx,
}: CommentIconsProps) => {
  const handleToggleOpen = () => {
    canOpen && toggleCheck();
  };

  const handleToggleFlag = () => {
    canFlag && toggleFlag();
  };

  // Concrete values, not palette paths: these feed react-icons' `color` attribute, not `sx`.
  const flagColor = !isChecked && isFlagged ? colors.critical[700] : colors.neutrals[200];
  const checkColor = isChecked ? themeColors.success[100] : colors.neutrals[200];

  return (
    <Box className="flex text-sm" sx={sx}>
      <AiFillFlag
        data-testid="comment-icons-flag"
        color={flagColor}
        onClick={handleToggleFlag}
        className={canFlag ? "cursor-pointer" : "cursor-not-allowed"}
      />
      <AiFillCheckCircle
        data-testid="comment-icons-check"
        color={checkColor}
        onClick={handleToggleOpen}
        className={classMerge("ml-3", canOpen ? "cursor-pointer" : "cursor-not-allowed")}
      />
    </Box>
  );
};
